import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import './styles/responsive.css'
import DesktopOnlyGate from './components/DesktopOnlyGate'
import NotFound from './views/not-found'
import Home from './views/home'
import Login from './pages/Login'
import StudentDashboard from './pages/StudentDashboard'
import TeacherDashboard from './pages/TeacherDashboard'
import InvigilatorDashboard from './pages/InvigilatorDashboard'
import AdminDashboard from './pages/AdminDashboard'
import TestList from './pages/TestList'
import TestTaking from './pages/TestTaking'
import TestResult from './pages/TestResult'
import TestDetails from './pages/TestDetails'
import TestHistory from './pages/TestHistory'
import MyPayments from './pages/MyPayments'
import TeacherCreateTest from './pages/TeacherCreateTest'
import TeacherTests from './pages/TeacherTests'
import TeacherTestView from './pages/TeacherTestView'
import TeacherProctoringDashboard from './pages/TeacherProctoringDashboard'
import InvigilatorSessions from './pages/InvigilatorSessions'
import InvigilatorFlagged from './pages/InvigilatorFlagged'
import VolunteerDashboard from './pages/VolunteerDashboard'
import VolunteerTests from './pages/VolunteerTests'
import VolunteerTestView from './pages/VolunteerTestView'
import VolunteerAttempts from './pages/VolunteerAttempts'
import VolunteerAttemptView from './pages/VolunteerAttemptView'
import VolunteerTasks from './pages/VolunteerTasks'
import VolunteerAnalytics from './pages/VolunteerAnalytics'
import VolunteerActivityLog from './pages/VolunteerActivityLog'
import AdminTests from './pages/AdminTests'
import AdminUsers from './pages/AdminUsers'
import AdminPayments from './pages/AdminPayments'
import FaceRegistration from './pages/FaceRegistration'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={NotFound} exact path="/not-found" />
        <Route component={Home} exact path="/" />
        <Route component={Login} exact path="/login" />

        {/* Student Routes */}
        <Route component={StudentDashboard} exact path="/student-dashboard" />
        <Route component={FaceRegistration} exact path="/face-registration" />
        <Route component={TestList} exact path="/available-tests" />
        <Route component={TestHistory} exact path="/test-history" />
        <Route component={MyPayments} exact path="/my-payments" />
        {/* Gated at the route, not inside the page: TestTaking's mount effect
            creates a TestAttempt and starts the timer, so it must never mount
            on a phone or tablet. */}
        <Route
          exact
          path="/test-taking/:testId"
          render={(props) => (
            <DesktopOnlyGate>
              <TestTaking {...props} />
            </DesktopOnlyGate>
          )}
        />
        <Route component={TestResult} exact path="/test-result" />
        <Route component={TestDetails} exact path="/test-details/:attemptId" />

        {/* Teacher Routes */}
        <Route component={TeacherDashboard} exact path="/teacher-dashboard" />
        <Route component={TeacherCreateTest} exact path="/teacher/create-test" />
        <Route component={TeacherTestView} exact path="/teacher/test/:testId" />
        <Route component={TeacherCreateTest} exact path="/teacher/test/:testId/edit" />
        <Route component={TeacherTests} exact path="/teacher/tests" />
        <Route component={TeacherTests} exact path="/teacher/my-tests" />
        <Route component={TeacherProctoringDashboard} exact path="/teacher/proctoring" />

        {/* Invigilator Routes */}
        <Route component={InvigilatorDashboard} exact path="/invigilator-dashboard" />
        <Route component={InvigilatorSessions} exact path="/invigilator/sessions" />
        <Route component={InvigilatorSessions} exact path="/invigilator/active-sessions" />
        <Route component={InvigilatorFlagged} exact path="/invigilator/flagged" />

        {/* Volunteer Routes */}
        <Route component={VolunteerDashboard} exact path="/volunteer-dashboard" />
        <Route component={VolunteerTests} exact path="/volunteer/tests" />
        <Route component={VolunteerTestView} exact path="/volunteer/test/:testId" />
        <Route component={VolunteerAttempts} exact path="/volunteer/attempts" />
        <Route component={VolunteerAttemptView} exact path="/volunteer/attempt/:attemptId" />
        <Route component={VolunteerTasks} exact path="/volunteer/tasks" />
        <Route component={VolunteerAnalytics} exact path="/volunteer/analytics" />
        <Route component={VolunteerActivityLog} exact path="/volunteer/activity-log" />

        {/* Admin Routes */}
        <Route component={AdminDashboard} exact path="/admin-dashboard" />
        <Route component={AdminTests} exact path="/admin/tests" />
        <Route component={AdminUsers} exact path="/admin/users" />
        <Route component={AdminPayments} exact path="/admin/payments" />

        <Route component={NotFound} path="*" />
        <Redirect to="/not-found" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
